export const UNCALCULABLE_FREQUENCIES = ["HOUR", "LITER", "KW", "KWH"];
export const ACCOMMODATION_PLACEHOLDER_SM =
  "https://media.foravilarentals.com/photos/placeholders/foravilarentals-accommodations-placeholders.png";
export const ACCOMMODATION_PLACEHOLDER_XL =
  "https://media.foravilarentals.com/photos/placeholders/foravilarentals-accommodations-placeholders-big.png";
